var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26396_249922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.804 16.8534C15.1607 16.8534 13.8287 15.5352 13.8287 13.9093C13.8287 12.2831 15.1607 10.9648 16.804 10.9648C18.4473 10.9648 19.7794 12.2831 19.7794 13.9093C19.7794 15.5352 18.4473 16.8534 16.804 16.8534ZM17.6947 8.24076V5.6215C18.3856 5.29858 18.8695 4.60696 18.8695 3.80432V3.74386C18.8695 2.63609 17.9537 1.72976 16.8343 1.72976H16.7735C15.6541 1.72976 14.7382 2.63609 14.7382 3.74386V3.80432C14.7382 4.60696 15.2221 5.29886 15.913 5.62178V8.24076C14.8844 8.39813 13.9446 8.81795 13.1695 9.43583L5.90238 3.84161C5.95034 3.65938 5.98403 3.47179 5.98432 3.27459C5.98546 2.02019 4.95942 1.0017 3.69128 1C2.42372 0.998589 1.39425 2.01426 1.39282 3.26894C1.3914 4.52362 2.41744 5.54211 3.68557 5.54352C4.09867 5.54409 4.48123 5.42797 4.81639 5.23925L11.9647 10.7425C11.3569 11.6505 11.0006 12.7382 11.0006 13.9093C11.0006 15.1351 11.392 16.2692 12.0532 17.2018L9.87951 19.3532C9.70764 19.3021 9.5295 19.2665 9.34051 19.2665C8.29876 19.2665 7.45401 20.1022 7.45401 21.1331C7.45401 22.1643 8.29876 23 9.34051 23C10.3825 23 11.227 22.1643 11.227 21.1331C11.227 20.9466 11.191 20.7701 11.1394 20.6L13.2897 18.472C14.2657 19.2091 15.4813 19.6521 16.804 19.6521C20.0092 19.6521 22.6071 17.0809 22.6071 13.9093C22.6071 11.038 20.4757 8.66596 17.6947 8.24076Z",
    fill: "#FF7A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26396_249922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2143,
    height: 22,
    fill: "white",
    transform: "translate(1.39282 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/Hubspot.4831002118abdf53db4567996e5d203d.svg";
export { ForwardRef as ReactComponent };